<template>
<div class="chapter">
<div class="inner_page">
<p class="part-title"><span>PART ONE</span></p>
<p class="part-center"><span><i>The Husband</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?98af9acc